/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2022 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { LogoIcon } from '@builddocs/icons'
import { Box, CircularProgress, Stack } from '@mui/material'
import clsx from 'clsx'
import { DisappearedLoading } from 'react-loadingg'

import styles from './style.module.scss'

type Props = {
  isPageLoader?: boolean
  isInline?: boolean
  isLogo?: boolean
  dark?: boolean
  height?: number | string
}

const LoadingSpinner = ({
  isPageLoader,
  isInline,
  isLogo,
  dark,
  height,
}: Props) => {
  const loadingClasses = clsx({
    [styles.loadingSpinner]: true,
    [styles.loadingSpinner_page]: isPageLoader,
  })

  if (isLogo) {
    return (
      <Stack
        alignItems="center"
        direction="column"
        height={height ?? '100%'}
        justifyContent="center"
        sx={{ backgroundColor: '#ffffff', color: '#333333' }}
      >
        <LogoIcon
          style={{
            width: '25%',
            height: '25%',
          }}
        />
      </Stack>
    )
  }

  if (isInline) {
    return (
      <Box className={loadingClasses}>
        <div style={{ width: 60 }}>
          <DisappearedLoading
            color={dark ? '#4A5568' : '#ffffff'}
            size="small"
          />
        </div>
      </Box>
    )
  }

  return (
    <div className={loadingClasses}>
      <Stack
        alignItems="center"
        height={height ?? '250px'}
        justifyContent="center"
        width="250px"
      >
        <CircularProgress
          sx={{
            color: '#4169E1',
          }}
        />
      </Stack>
    </div>
  )
}

export default LoadingSpinner
